import { render } from "./VisionMission.vue?vue&type=template&id=3d6045ec&scoped=true"
import script from "./VisionMission.vue?vue&type=script&lang=js"
export * from "./VisionMission.vue?vue&type=script&lang=js"

import "./VisionMission.vue?vue&type=style&index=0&id=3d6045ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6045ec"]])

export default __exports__